// extracted by mini-css-extract-plugin
export default {"singleResultContainer":"sytI0N0i_h4UzGVK6dlM"};